
function VideoWidget(props) {
  let videoURLArr = props.video_url.split("/");
  let src;
  if (videoURLArr.length === 5) {
    src = `https://player.vimeo.com/video/${videoURLArr[videoURLArr.length - 2]}/${videoURLArr[videoURLArr.length - 1]}`
  } else if (videoURLArr.length === 4) {
    src = `https://player.vimeo.com/video/${videoURLArr[videoURLArr.length - 1]}`;
  }
  return (
    <div className="EmployeeReaderWidget VideoEmployeeReaderWidget">
      <iframe
        src={src}
        width="100%"
        height="500"
        allow="autoplay; fullscreen; picture-in-picture"
        frameBorder="0"
        allowFullScreen
      />
    </div>
  )
}

export { VideoWidget }
